import { Amplify } from 'aws-amplify'
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito'
import { CookieStorage } from 'aws-amplify/utils'

import { env } from '@/env'

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: env.VITE_COGNITO_USER_POOL_ID,
      userPoolClientId: env.VITE_COGNITO_APP_CLIENT_ID,
    },
  },
})

cognitoUserPoolsTokenProvider.setKeyValueStorage(
  new CookieStorage({
    domain: env.VITE_COGNITO_COOKIE_DOMAIN || window.location.hostname,
    path: '/',
    expires: 1,
    secure: true,
  }),
)
